//Version 2.3
//Rebuilding the file from FOS
//Removed detection browser
//Removed notification system

//Version 2.2
//Added osh1.js

//Version 2.1.4
//Changed DB credentials
//
//Version 2.1
//Added Trading Time
//Added Connection

//Version 2.0
//Rebuilt.
//Included:
//More fields
//Automated ITM Calculation
//Much more!

//Version 1.5
// Added loading signals
//Version 1.4
//changed number of signals per pageg
//removed refreshing on delete.

//Version 1.3
//added Session cancelled

//Version 1.2
//added timestamp*1
jQuery(document).ready(function ($) {
    // Detect timezone switch
    //console.log(localStorage.timezoneset);
    if (localStorage.timezoneset == "1") {
        $("#localswitch").prop("checked", true);
        //console.log("storage local timezone");
    } else {
        $("#localswitch").prop("checked", false);
        //console.log("storage GMT timezone");
    }

    /*
  ================================================================================================================================
  ================================================================================================================================
  Init Firebas and constants
  ================================================================================================================================
  ================================================================================================================================
  */
    // Initialize Firebase
    var config = {
        apiKey: "AIzaSyC7qpoGNBN3q80OrIoYTFMkuZNvk1QtmLE",
        authDomain: "os-hourly.firebaseapp.com",
        databaseURL: "https://os-hourly.firebaseio.com",
        projectId: "os-hourly",
        storageBucket: "os-hourly.appspot.com",
        messagingSenderId: "752217169784",
    };
    firebase.initializeApp(config);

    //Get all elements
    //setup Thresholds of Showng messages

    const minSignalsLevel = 30;
    //console.log(minSignalsLevel);
    //const minPreSignalsLevel = 5;
    //Notused
    //const maxSignalsLevel = 5;

    //Define Firebase Reference
    //Main
    const connectedRef = firebase.database().ref(".info/connected");
    const signalsRef = firebase.database().ref("osh1/robot");
    //const preSignalsRef = firebase.database().ref('os/presignals');
    const statusRef = firebase.database().ref("osh1/status");
    const maintenanceRef = firebase.database().ref("maintenance");
    //Advanced
    const LoadSignals = signalsRef.limitToLast(minSignalsLevel);

    //const LoadPreSignals = preSignalsRef.limitToLast(minPreSignalsLevel);

    //const LoadPreSignalsLast = preSignalsRef.limitToLast(maxSignalsLevel);

    /*
  ================================================================================================================================
  ================================================================================================================================
  Define Functions
  ================================================================================================================================
  ================================================================================================================================
  */
    //define time

    // Define Time function - Timestamp to UTC
    function timeStampToFull(timeStamp) {
        if (localStorage.timezoneset == "1") {
            var humanTime = moment(timeStamp * 1).format("DD-MM-YYYY HH:mm:ss");
        } else {
            var humanTime = moment
                .utc(timeStamp * 1)
                .format("DD-MM-YYYY HH:mm:ss");
        }
        return humanTime;
    }
    function timeStampToPart(timeStamp) {
        if (localStorage.timezoneset == "1") {
            var humanTime = moment(timeStamp * 1).format("HH:mm");
        } else {
            var humanTime = moment.utc(timeStamp * 1).format("HH:mm");
        }
        return humanTime;
    }

    function timeStampToPartSeconds(timeStamp) {
        if (localStorage.timezoneset == "1") {
            var humanTime = moment(timeStamp * 1).format("HH:mm:ss");
        } else {
            var humanTime = moment.utc(timeStamp * 1).format("HH:mm:ss");
        }
        return humanTime;
    }

    //Update timer start
    var time = 3000; //in seconds
    var duration = moment.duration(time * 1000, "milliseconds");
    var interval = 1000;

    setInterval(function () {
        time--;
        duration = moment.duration(
            duration.asMilliseconds() - interval,
            "milliseconds"
        );
        // $("#reloadtime").text(
        //     moment(duration.asMilliseconds()).format("mm:ss")
        // );
        if (time === 0) {
            // $("#reloaddiv").text("Reload the page!");
            // $("#reloaddiv").css({ color: "red", "font-weight": "800" });
        }
    }, 1000);

    //Function
    function playSound(filename) {
        //console.log(time);
        if (time < 2980) {
            document.getElementById("sound").innerHTML =
                '<audio autoplay="autoplay"><source src="' +
                filename +
                '.mp3" type="audio/mpeg" /><source src="' +
                filename +
                '.ogg" type="audio/ogg" /><embed hidden="true" autostart="true" loop="false" src="' +
                filename +
                '.mp3" /></audio>';
        }
    }
    //Stats
    // function writeStatistics(totalPercentage) {
    //     if (totalPercentage[1] == 0) {
    //         $("#fbdate").html(
    //             date +
    //                 " we have issued 0 binary options signals.<br>All trading sessions were cancelled due to market conditions."
    //         );
    //     } else if (totalPercentage[1] != 0 && totalPercentage[4] == 0) {
    //         $("#fbdate").html(
    //             totalPercentage[0] +
    //                 " we have issued " +
    //                 totalPercentage[1] +
    //                 " binary options signals.<br>" +
    //                 totalPercentage[2] +
    //                 " of them were won, " +
    //                 totalPercentage[3] +
    //                 " were lost.<br>The trading signals ratio is " +
    //                 totalPercentage[5] +
    //                 "%."
    //         );
    //     } else {
    //         $("#fbdate").html(
    //             totalPercentage[0] +
    //                 " we have issued " +
    //                 totalPercentage[1] +
    //                 " binary options signals.<br>" +
    //                 totalPercentage[2] +
    //                 " of them were won, " +
    //                 totalPercentage[3] +
    //                 " were lost and " +
    //                 totalPercentage[4] +
    //                 " closed in tie. <br>The trading signals ratio is " +
    //                 totalPercentage[5] +
    //                 "%."
    //         );
    //     }
    // }
    // function writeStatisticsPos(totalPercentage) {
    //     if (totalPercentage[1] == 0) {
    //         $("#fbdatePossible").html(
    //             date +
    //                 " we have issued 0 binary options signals.<br>All trading sessions were cancelled due to market conditions."
    //         );
    //     } else if (totalPercentage[1] != 0 && totalPercentage[4] == 0) {
    //         $("#fbdatePossible").html(
    //             totalPercentage[0] +
    //                 " you could get " +
    //                 totalPercentage[1] +
    //                 " binary options trades.<br>" +
    //                 totalPercentage[2] +
    //                 " of them were won, " +
    //                 totalPercentage[3] +
    //                 " were lost. Price was not reached in " +
    //                 totalPercentage[6] +
    //                 " trades.<br>The trading signals ratio, excluding not reached is " +
    //                 totalPercentage[5] +
    //                 "%."
    //         );
    //     } else {
    //         $("#fbdatePossible").html(
    //             totalPercentage[0] +
    //                 " we have issued " +
    //                 totalPercentage[1] +
    //                 " binary options signals.<br>" +
    //                 totalPercentage[2] +
    //                 " of them were won, " +
    //                 totalPercentage[3] +
    //                 " were lost and " +
    //                 totalPercentage[4] +
    //                 " closed in tie. Price was not reached in " +
    //                 totalPercentage[6] +
    //                 " trades.<br>The trading signals ratio, excluding not reached is " +
    //                 totalPercentage[5] +
    //                 "%."
    //         );
    //     }
    // }
    /*
  ================================================================================================================================
  ================================================================================================================================
  Messaging Load
  ================================================================================================================================
  ================================================================================================================================
  */
    // IDs of divs that display Instance ID token UI or request permission UI.

    //     const messaging = firebase.messaging();

    //     // Callback fired if Instance ID token is updated.
    //     messaging.onTokenRefresh(function () {
    //         messaging
    //             .getToken()
    //             .then(function (refreshedToken) {
    //                 setTokenSentToServer(false);

    //                 sendTokenToServer(refreshedToken);

    //                 // Display new Instance ID token and clear UI of all previous messages.
    //                 resetUI();
    //             })
    //             .catch(function (err) {
    //                 //console.log('Unable to retrieve refreshed token ', err);
    //                 $("#notificationerror").text(
    //                     "Error with notification system" + err
    //                 );
    //                 $("#notificationerror").show();
    //                 $("#notifications").hide();
    //                 $("#notificationtext").hide();
    //             });
    //     });

    //     // Handle incoming messages. Called when:
    //     // - a message is received while the app has focus
    //     // - the user clicks on an app notification created by a sevice worker
    //     //   `messaging.setBackgroundMessageHandler` handler.
    //     // messaging.onMessage(function (payload) {
    //         //console.log("Message received. ", payload);
    //     });
    //     // [END receive_message]

    //     function resetUI() {
    //         //clearMessages();
    //         //showToken('loading...');
    //         // [START get_token]
    //         // Get Instance ID token. Initially this makes a network call, once retrieved
    //         // subsequent calls to getToken will return from cache.
    //         messaging
    //             .getToken()
    //             .then(function (currentToken) {
    //                 if (currentToken) {
    //                     //console.log(currentToken);
    //                     sendTokenToServer(currentToken);
    //                     //updateUIForPushEnabled(currentToken);
    //                     $("#notifications").hide();
    //                     $("#notificationtext").hide();
    //                 } else {
    //                     // Show permission request.
    //                     //console.log('No Instance ID token available. Request permission to generate one. Contact us if you need help!');
    //                     $("#notifications").show();
    //                     $("#notificationtext").show();
    //                     // Show permission UI.
    //                     //updateUIForPushPermissionRequired();
    //                     setTokenSentToServer(false);
    //                 }
    //             })
    //             .catch(function (err) {
    //                 console.log("An error occurred while retrieving token. ", err);
    //                 //showToken('Error retrieving Instance ID token. ', err);
    //                 $("#notificationerror").text(
    //                     "Error with notification system. Possibly you have denied permissions for the website. Clean your browser setting or contact us."
    //                 );
    //                 $("#notifications").hide();
    //                 $("#notificationtext").hide();
    //                 $("#notificationerror").show();
    //                 setTokenSentToServer(false);
    //             });
    //     }
    //     // [END get_token]
    //     /*
    //   function showToken(currentToken) {
    //     // Show token in console and UI.
    //     var tokenElement = document.querySelector('#token');
    //     tokenElement.textContent = currentToken;
    //   }
    //   */
    //     // Send the Instance ID token your application server, so that it can:
    //     // - send messages back to this app
    //     // - subscribe/unsubscribe the token from topics
    //     function sendTokenToServer(currentToken) {
    //         if (!isTokenSentToServer()) {
    //             //console.log('Sending token to server...');
    //             $.ajax({
    //                 accept: "application/json",
    //                 type: "POST",
    //                 url:
    //                     "https://iid.googleapis.com/iid/v1/" +
    //                     currentToken +
    //                     "/rel/topics/freesignals",
    //                 headers: {
    //                     Authorization:
    //                         "key=AAAA1IWEa3k:APA91bFGoErhYs1v1O-SVHeZOnDtM6Hp77fYA-bC1q3rM20VVGzqukuuQb_TJSZjdPISvF4jve2FqYMat0Z6Ck6zd5WQesRSYlH7EdphAD8Y2ke71rzogyUAeB7QpxjiCIzSPCoYtOlN",
    //                     "Content-Type": "application/json",
    //                 },
    //             });
    //             setTokenSentToServer(true);
    //         } else {
    //             //console.log('Token already sent to server so won\'t send it again ' +  'unless it changes');
    //         }
    //     }

    //     function isTokenSentToServer() {
    //         if (window.localStorage.getItem("sentToServer") == 1) {
    //             return true;
    //         }
    //         return false;
    //     }

    //     function setTokenSentToServer(sent) {
    //         if (sent) {
    //             window.localStorage.setItem("sentToServer", 1);
    //         } else {
    //             window.localStorage.setItem("sentToServer", 0);
    //         }
    //     }

    //     /*
    //   function showHideDiv(divId, show) {
    //     const div = document.querySelector('#' + divId);
    //     if (show) {
    //       div.style = "display: visible";
    //     } else {
    //       div.style = "display: none";
    //     }
    //   }
    //   */

    //     function requestPermission() {
    //         //console.log('Requesting permission...');
    //         // [START request_permission]
    //         messaging
    //             .requestPermission()
    //             .then(function () {
    //                 //console.log('Notification permission granted.');
    //                 // TODO(developer): Retrieve an Instance ID token for use with FCM.
    //                 // [START_EXCLUDE]
    //                 // In many cases once an app has been granted notification permission, it
    //                 // should update its UI reflecting this.
    //                 resetUI();
    //                 // [END_EXCLUDE]
    //             })
    //             .catch(function (err) {
    //                 $("#notifications").hide();
    //                 $("#notificationtext").hide();
    //                 $("#notificationerror").text(
    //                     "Unable to get permission to notify."
    //                 );
    //                 $("#notificationerror").show();
    //                 console.log("Unable to get permission to notify.", err);
    //             });
    //         // [END request_permission]
    //     }

    //     function deleteToken() {
    //         // Delete Instance ID token.
    //         // [START delete_token]
    //         messaging
    //             .getToken()
    //             .then(function (currentToken) {
    //                 messaging
    //                     .deleteToken(currentToken)
    //                     .then(function () {
    //                         //console.log('Token deleted.');
    //                         setTokenSentToServer(false);
    //                         // [START_EXCLUDE]
    //                         // Once token is deleted update UI.
    //                         resetUI();
    //                         // [END_EXCLUDE]
    //                     })
    //                     .catch(function (err) {
    //                         //console.log('Unable to delete token. ', err);
    //                     });
    //                 // [END delete_token]
    //             })
    //             .catch(function (err) {
    //                 //console.log('Error retrieving Instance ID token. ', err);
    //                 //showToken('Error retrieving Instance ID token. ', err);
    //             });
    //     }
    //     /*

    //   }
    //   */
    //     resetUI();

    //     //////////////////////////////////////Notiication clicks ///////////////////////////////////////
    //     $("#notifications").click(function () {
    //         requestPermission();
    //     });

    /*
  ================================================================================================================================
  ================================================================================================================================
  Define clicks
  ================================================================================================================================
  ================================================================================================================================
  */

    $("#localswitch").click(function () {
        //check if session switch is checked and define session type on the current time. After that init writesession function
        if ($("#localswitch").prop("checked")) {
            localStorage.timezoneset = "1";
            //console.log("Storage was set to local");
        }
        //in case switch is not checked or any other error - close session and write DB
        else {
            localStorage.timezoneset = "0";
            //console.log("starage set to GMT");
        }
        location.reload();
    });
    $("#signalscontent").show();
    //Loading Proces

    /* Set number of signals

});


   /*
  ================================================================================================================================
  ================================================================================================================================
  Signals Load
  ================================================================================================================================
  ================================================================================================================================
  */
    connectedRef.on("value", function (snap) {
        if (snap.val() === true) {
            $("#discon").hide();
            $("#conn").show();
            $(".signalsprocessing").show();
        } else {
            $("#conn").hide();
            $(".signalsprocessing").hide();
            $("#discon").show();
        }
    });

    LoadSignals.on("child_added", (snap) => {
        signalsTable = snap.exportVal();

        //get snap key
        var tableKey = snap.key;
        //console.log(signalsTable);
        //convert time from stamp to UTC
        playSound("https://options-signals.com/audio/signal");
        var tableTime = timeStampToFull(signalsTable.time);
        //Update date lablel
        //Prepend new signals to the tableSignals
        var exists = $("#" + tableKey).length;
        if (exists == 0) {
            $("#tableSignals").prepend(
                "<tr id=" +
                    tableKey +
                    " class='POS" +
                    signalsTable.statusHl +
                    " " +
                    signalsTable.signalStatus +
                    " " +
                    signalsTable.asset +
                    "'><td class='timeRow'>" +
                    tableTime +
                    "</td><td class='pricesigcur' >" +
                    signalsTable.currentPrice +
                    "</td><td id='directionsig' class='directionsig " +
                    signalsTable.direction +
                    "'></td><td class='asset " +
                    signalsTable.asset +
                    "'>" +
                    signalsTable.asset +
                    "</td><td class='pricesig' >" +
                    signalsTable.price +
                    "</td><td class='expirytimesig'>" +
                    timeStampToPart(signalsTable.expiryTime) +
                    "</td><td class='expirypricesig hide" +
                    signalsTable.expiryPrice +
                    "'><span>" +
                    signalsTable.expiryPrice +
                    "</span></td><td class='reachedprice hide" +
                    signalsTable.priceReached +
                    "'><span>" +
                    signalsTable.priceReached +
                    "</span></td><td class='signalstatus hide" +
                    signalsTable.signalStatus +
                    " stat" +
                    signalsTable.signalStatus +
                    "'></td><td class='hightimesig hide" +
                    signalsTable.highTime +
                    "'><span>" +
                    timeStampToPartSeconds(signalsTable.highTime) +
                    "</span></td><td class='highPrice hide" +
                    signalsTable.highPrice +
                    "'><span>" +
                    signalsTable.highPrice +
                    "</span></td><td class='highPriceChanged hide" +
                    signalsTable.highPriceChanged +
                    "'><span>" +
                    signalsTable.highPriceChanged +
                    "</span></td><td class='lowtimesig hide" +
                    signalsTable.lowTime +
                    "'><span>" +
                    timeStampToPartSeconds(signalsTable.lowTime) +
                    "</span></td><td class='lowPrice hide" +
                    signalsTable.lowPrice +
                    "'><span>" +
                    signalsTable.lowPrice +
                    "</span></td><td class='lowPriceChanged hide" +
                    signalsTable.lowPriceChanged +
                    "'><span>" +
                    signalsTable.lowPriceChanged +
                    "</span></td><td class='besttimesig hide" +
                    signalsTable.bestTime +
                    "'><span>" +
                    timeStampToPartSeconds(signalsTable.bestTime) +
                    "</span></td><td class='bestPrice hide" +
                    signalsTable.bestPrice +
                    "'><span>" +
                    signalsTable.bestPrice +
                    "</span></td><td class='beststatus hide" +
                    signalsTable.statusHl +
                    " stat" +
                    signalsTable.statusHl +
                    "'></td></tr>"
            );
        }
        $("#" + tableKey).addClass("newitem");
        setTimeout(function () {
            $("#" + tableKey).removeClass("newitem");
        }, 2000);

        // var rowTotal = $("#tableSignals tr").length;
        // var rowWon = $("#tableSignals tr.WON").length;
        // var rowLoss = $("#tableSignals tr.LOSS").length;
        // var rowTie = $("#tableSignals tr.TIE").length;
        // var excludeTie = rowTotal - rowTie;
        // var percentage = (rowWon / excludeTie) * 100;
        // var totalPercentage = [
        //     moment().utc(),
        //     rowTotal,
        //     rowWon,
        //     rowLoss,
        //     rowTie,
        //     percentage.toFixed(2),
        // ];
        //writeStatistics(totalPercentage);

        // Possible Won
        // var rowTotalPos = $("#tableSignals tr").length;
        // var rowWonPos = $("#tableSignals tr.POSWON").length;
        // var rowLossPos = $("#tableSignals tr.POSLOSS").length;
        // var rowTiePos = $("#tableSignals tr.POSTIE").length;
        // var rowNotReachedPos = $("#tableSignals tr.POSNOTREACHED").length;
        // var excludeTiePos = rowTotalPos - rowTiePos - rowNotReachedPos;
        // var percentagePos = (rowWonPos / excludeTiePos) * 100;
        // var totalPercentagePos = [
        //     moment().utc(),
        //     rowTotalPos,
        //     rowWonPos,
        //     rowLossPos,
        //     rowTiePos,
        //     percentagePos.toFixed(2),
        //     rowNotReachedPos,
        // ];
        //writeStatisticsPos(totalPercentagePos);
    });

    LoadSignals.on("child_removed", function (snap) {
        //Define the key of deleted signal
        var tableKey = snap.key;
        //remove the line with the signal
        $("#" + tableKey).remove();
    });

    LoadSignals.on("child_changed", function (snap) {
        //get snapshot as Object
        signalsTable = snap.exportVal();

        //get snapshot as Object
        var tableKey = snap.key;

        //convert time from stamp to UTC
        var tableTime = timeStampToFull(signalsTable.time);

        //replace the changed signal with new one
        $("#" + tableKey).replaceWith(
            "<tr id=" +
                tableKey +
                " class='POS" +
                signalsTable.statusHl +
                " " +
                signalsTable.signalStatus +
                " " +
                signalsTable.asset +
                "'><td class='timeRow'>" +
                tableTime +
                "</td><td class='pricesigcur' >" +
                signalsTable.currentPrice +
                "</td><td id='directionsig' class='directionsig " +
                signalsTable.direction +
                "'></td><td class='asset " +
                signalsTable.asset +
                "'>" +
                signalsTable.asset +
                "</td><td class='pricesig' >" +
                signalsTable.price +
                "</td><td class='expirytimesig'>" +
                timeStampToPart(signalsTable.expiryTime) +
                "</td><td class='expirypricesig hide" +
                signalsTable.expiryPrice +
                "'><span>" +
                signalsTable.expiryPrice +
                "</span></td><td class='reachedprice hide" +
                signalsTable.priceReached +
                "'>" +
                signalsTable.priceReached +
                "</td><td class='signalstatus hide" +
                signalsTable.signalStatus +
                " stat" +
                signalsTable.signalStatus +
                "'></td><td class='hightimesig hide" +
                signalsTable.highTime +
                "'><span>" +
                timeStampToPartSeconds(signalsTable.highTime) +
                "</span></td><td class='highPrice hide" +
                signalsTable.highPrice +
                "'>" +
                signalsTable.highPrice +
                "</td><td class='highPriceChanged hide" +
                signalsTable.highPriceChanged +
                "'><span>" +
                signalsTable.highPriceChanged +
                "</span></td><td class='lowtimesig hide" +
                signalsTable.lowTime +
                "'>" +
                timeStampToPartSeconds(signalsTable.lowTime) +
                "</td><td class='lowPrice hide" +
                signalsTable.lowPrice +
                "'><span>" +
                signalsTable.lowPrice +
                "</span></td><td class='lowPriceChanged hide" +
                signalsTable.lowPriceChanged +
                "'>" +
                signalsTable.lowPriceChanged +
                "</td><td class='besttimesig hide" +
                signalsTable.bestTime +
                "'><span>" +
                timeStampToPartSeconds(signalsTable.bestTime) +
                "</span></td><td class='bestPrice hide" +
                signalsTable.bestPrice +
                "'>" +
                signalsTable.bestPrice +
                "</td><td class='beststatus hide" +
                signalsTable.statusHl +
                " stat" +
                signalsTable.statusHl +
                "'></td></tr>"
        );

        //console.log(signalsTable.signalStatus);
        if (signalsTable.statusHl == "LOSS") {
            $("#" + tableKey).toggleClass("lostitem");
            setTimeout(function () {
                $("#" + tableKey).toggleClass("lostitem");
            }, 2000);
        } else if (signalsTable.statusHl == "WON") {
            $("#" + tableKey).toggleClass("wonitem");
            setTimeout(function () {
                $("#" + tableKey).toggleClass("wonitem");
            }, 2000);
        }

        // var rowTotal = $("#tableSignals tr").length;
        // var rowWon = $("#tableSignals tr.WON").length;
        // var rowLoss = $("#tableSignals tr.LOSS").length;
        // var rowTie = $("#tableSignals tr.TIE").length;
        // var excludeTie = rowTotal - rowTie;
        // var percentage = (rowWon / excludeTie) * 100;
        // var totalPercentage = [
        //     moment().utc(),
        //     rowTotal,
        //     rowWon,
        //     rowLoss,
        //     rowTie,
        //     percentage.toFixed(2),
        // ];

        //writeStatistics(totalPercentage);
        // var rowTotalPos = $("#tableSignals tr").length;
        // var rowWonPos = $("#tableSignals tr.POSWON").length;
        // var rowLossPos = $("#tableSignals tr.POSLOSS").length;
        // var rowTiePos = $("#tableSignals tr.POSTIE").length;
        // var rowNotReachedPos = $("#tableSignals tr.POSNOTREACHED").length;
        // var excludeTiePos = rowTotalPos - rowTiePos - rowNotReachedPos;
        // var percentagePos = (rowWonPos / excludeTiePos) * 100;
        // var totalPercentagePos = [
        //     moment().utc(),
        //     rowTotalPos,
        //     rowWonPos,
        //     rowLossPos,
        //     rowTiePos,
        //     percentagePos.toFixed(2),
        //     rowNotReachedPos,
        // ];
        //writeStatisticsPos(totalPercentagePos);
        //assets stats
    });

    /*
  ================================================================================================================================
  ================================================================================================================================
  Presignals Load
  ================================================================================================================================
  ================================================================================================================================
  
  LoadPreSignals.on('child_added', function(snap) {

        //get snapshot as Object
        preSignalsTable=snap.exportVal();

        //get snap key
        var tableKey = snap.key;
        
        //convert time from stamp to UTC
        var tableTime = timeStampToFull(preSignalsTable.time);
        playSound('https://free-options-signals.com/audio/presignal');
        //Prepend new signals to the tableSignals       
        var exists = $("#"+tableKey).length;   
        if ( exists == 0) {
          $("#tablePreSignals").prepend(
            "<tr id="+tableKey+"><td>" + tableTime + "</td><td id='directionpre' class=" + preSignalsTable.direction + "></td><td class='assetpre' >" + preSignalsTable.asset + "</td><td class='pricepre' >" + preSignalsTable.price + "</td><td class='expirytimepre'>" + timeStampToPart(preSignalsTable.expiryTime) +"</td></tr>"
            );
        };
        
        $("#"+tableKey).addClass("newitem");
        setTimeout( function(){ 
          $("#"+tableKey).removeClass("newitem");
        }  , 2000 );
      });

  //Pre Signal changed
  LoadPreSignals.on('child_changed', function(snap) {
        //get snapshot as Object
        preSignalsTable=snap.exportVal();

        //get snapshot as Object
        var tableKey = snap.key;

        //convert time from stamp to UTC
        var tableTime = timeStampToFull(preSignalsTable.time);

        //replace the changed signal with new one
        $("#"+tableKey).replaceWith(
          "<tr id="+tableKey+"><td>" + tableTime + "</td><td id='directionpre' class=" + preSignalsTable.direction + "></td><td class='assetpre' >" + preSignalsTable.asset + "</td><td class='pricepre' >" + preSignalsTable.price + "</td><td class='expirytimepre'>" + timeStampToPart(preSignalsTable.expiryTime) +"</td></tr>"
          );
      });

  //Pre Signal removed
  LoadPreSignals.on('child_removed', function(snap) {
        //Define the key of deleted signal
        var tableKey = snap.key;
        //remove the line with the signal
        $("#"+tableKey).remove();
      });

  /*
  ================================================================================================================================
  ================================================================================================================================
  Session status 
  ================================================================================================================================
  ================================================================================================================================
  */

    //Read session status and write it
    statusRef.on("value", function (snap) {
        var sessionStatus = snap.child("currentSessionStatus").val();

        if (sessionStatus == 0) {
            $("#wait").hide();
            $("#stopwait").show();
        } else {
            $("#stopwait").hide();
            $("#wait").show();
        }
    });
    /*
  ================================================================================================================================
  ================================================================================================================================
  Maintenance status
  ================================================================================================================================
  ================================================================================================================================
  */
    //Read Maintenance status and write it
    maintenanceRef.on("value", function (snap) {
        var maintenanceStatus = snap.child("maintenanceStatus").val();

        if (maintenanceStatus == 1) {
            $("#maintenancediv").show();
            $(".signalsprocessing").hide();
            $("#controldiv").hide();
        } else if (maintenanceStatus == 0) {
            $("#maintenancediv").hide();
            $(".signalsprocessing").show();
            $("#controldiv").show();
        } else {
            $("#maintenancediv").show();
            $(".signalsprocessing").hide();
            $("#controldiv").hide();
        }
    });

    /*
  ================================================================================================================================
  ================================================================================================================================
  Show authorized
  ================================================================================================================================
  ================================================================================================================================
  */
    //Show content
    // $("#logedincontent").show();
});
